const appConfig = {
  websiteBaseAddress: 'https://sergeysolovev.com'
};

export default appConfig;
